import React, { Component } from 'react'

import classes from './PasswordPolicy.scss'

import {
  checkValidity,
  updateFilterOptions,
  getPageStatus,
  updateObject
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Button from '../../../../components/UI/Button/Button'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import Collapse from '../../../../components/UI/Collapse/Collapse'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/Settings/PasswordPolicy/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import DataTable from '../../../../components/DataTable/DataTable'
import Alert from '../../../../components/Alert/Alert'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
class PasswordPolicy extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    actionRecordId: null,
    formIsValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      general: {
        title: this.props.translate('general'),
        open: true,
        form: {
          password_policy_name: {
            label: this.props.translate('passwordPolicy'),
            elementType: 'input',
            elementConfig: {
              placeholder: this.props.translate('passwordPolicy')
            },
            value: '',
            validation: {
              required: true
            },
            valid: false,
            touched: false,
            error: null
          },
          is_change_require: {
            title: this.props.translate('changeable'),
            elementType: 'toggleCheckbox',
            open: false,
            validation: false,
            valid: true,
            form: {
              min_age: {
                label: this.props.translate('minimumAge'),
                elementType: 'newselect',
                elementConfig: {
                  type: 'text',
                  placeholder: this.props.translate('select') + this.props.translate('minimumAge'),
                  options: [
                    { value: 0, label: 'None' },
                    { value: 300, label: '5 ' + this.props.translate('minutes') },
                    { value: 600, label: '10 ' + this.props.translate('minutes') },
                    { value: 1800, label: '30 ' + this.props.translate('minutes') },
                    { value: 3600, label: '1 ' + this.props.translate('hour') },
                    { value: 7200, label: '2 ' + this.props.translate('hours') },
                    { value: 10800, label: '3 ' + this.props.translate('hours') },
                    { value: 21600, label: '6 ' + this.props.translate('hours') },
                    { value: 43200, label: '12 ' + this.props.translate('hours') },
                    { value: 86400, label: '1 ' + this.props.translate('day') },
                    { value: 172800, label: '2 ' + this.props.translate('days') },
                    { value: 259200, label: '3 ' + this.props.translate('days') },
                    { value: 345600, label: '4 ' + this.props.translate('days') },
                    { value: 432000, label: '5 ' + this.props.translate('days') },
                    { value: 518400, label: '6 ' + this.props.translate('days') },
                    { value: 604800, label: '1 ' + this.props.translate('week') }
                  ]
                },
                value: {},
                validation: false,
                valid: true,
                touched: false,
                error: null
              }
            }
          },
          reset_ticket_max_age: {
            label: this.props.translate('resetTicketMaxAge'),
            elementType: 'newselect',
            elementConfig: {
              type: 'text',
              placeholder:
                this.props.translate('select') + this.props.translate('resetTicketMaxAge'),
              options: [
                { value: 0, label: 'Enternal' },
                { value: 300, label: '5 ' + this.props.translate('minutes') },
                { value: 600, label: '10 ' + this.props.translate('minutes') },
                { value: 1800, label: '30 ' + this.props.translate('minutes') },
                { value: 3600, label: '1 ' + this.props.translate('hour') },
                { value: 7200, label: '2 ' + this.props.translate('hours') },
                { value: 10800, label: '3 ' + this.props.translate('hours') },
                { value: 21600, label: '6 ' + this.props.translate('hours') },
                { value: 43200, label: '12 ' + this.props.translate('hours') },
                { value: 86400, label: '1 ' + this.props.translate('day') },
                { value: 172800, label: '2 ' + this.props.translate('days') },
                { value: 259200, label: '3 ' + this.props.translate('days') },
                { value: 345600, label: '4 ' + this.props.translate('days') },
                { value: 432000, label: '5 ' + this.props.translate('days') },
                { value: 518400, label: '6 ' + this.props.translate('days') },
                { value: 604800, label: '1 ' + this.props.translate('week') }
              ]
            },
            value: {},
            validation: {
              required: true
            },
            valid: false,
            touched: false,
            error: null
          },
          is_active: {
            label: this.props.translate('active'),
            elementType: 'checkbox',
            value: true,
            validation: false,
            valid: true
          }
        }
      },
      password_syntax_checking: {
        title: this.props.translate('passwordSyntaxchecking'),
        open: false,
        form: {
          is_check_syntax: {
            title: this.props.translate('syntaxCheckingEnabled'),
            elementType: 'toggleCheckbox',
            open: false,
            validation: false,
            valid: true,
            form: {
              min_alphanumeric: {
                label: this.props.translate('minimumAlphaNumeric'),
                elementType: 'input',
                elementConfig: {
                  placeholder: '0'
                },
                value: '',
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              min_length: {
                label: this.props.translate('minimumLength'),
                elementType: 'input',
                elementConfig: {
                  placeholder: '0'
                },
                value: '',
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              min_lower_case: {
                label: this.props.translate('minimumLowerCase'),
                elementType: 'input',
                elementConfig: {
                  placeholder: '0'
                },
                value: '',
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              min_number: {
                label: this.props.translate('minimumNumbers'),
                elementType: 'input',
                elementConfig: {
                  placeholder: '0'
                },
                value: '',
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              min_symbol: {
                label: this.props.translate('minimumSymbols'),
                elementType: 'input',
                elementConfig: {
                  placeholder: '0'
                },
                value: '',
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              min_upper_case: {
                label: this.props.translate('minimumUpperCase'),
                elementType: 'input',
                elementConfig: {
                  placeholder: '0'
                },
                value: '',
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              regex: {
                label: this.props.translate('regularExpression'),
                elementType: 'input',
                elementConfig: {
                  placeholder: this.props.translate('regularExpression')
                },
                value: '',
                validation: false,
                valid: true,
                touched: false,
                error: null
              }
            }
          }
        }
      },
      password_history: {
        title: this.props.translate('passwordHistory'),
        open: false,
        form: {
          is_history: {
            title: this.props.translate('historyEnabled'),
            elementType: 'toggleCheckbox',
            open: false,
            validation: false,
            valid: true,
            form: {
              history_count: {
                label: 'History Count',
                elementType: 'newselect',
                elementConfig: {
                  type: 'text',
                  placeholder: 'Select History Count',
                  options: [
                    { value: 2, label: '2' },
                    { value: 3, label: '3' },
                    { value: 4, label: '4' },
                    { value: 5, label: '5' },
                    { value: 6, label: '6' },
                    { value: 7, label: '7' },
                    { value: 8, label: '8' },
                    { value: 9, label: '9' },
                    { value: 10, label: '10' },
                    { value: 11, label: '11' },
                    { value: 12, label: '12' },
                    { value: 13, label: '13' },
                    { value: 14, label: '14' },
                    { value: 15, label: '15' },
                    { value: 16, label: '16' },
                    { value: 17, label: '17' },
                    { value: 18, label: '18' },
                    { value: 19, label: '19' },
                    { value: 20, label: '20' },
                    { value: 21, label: '21' },
                    { value: 22, label: '22' },
                    { value: 23, label: '23' },
                    { value: 24, label: '24' }
                  ]
                },
                value: {},
                validation: false,
                valid: true,
                touched: false,
                error: null
              }
            }
          }
        }
      },
      is_expire_col: {
        title: this.props.translate('passwordExpiration'),
        open: false,
        form: {
          is_expire: {
            title: this.props.translate('historyExpriation'),
            elementType: 'toggleCheckbox',
            open: false,
            validation: false,
            valid: true,
            form: {
              max_age: {
                label: this.props.translate('maximemAge'),
                elementType: 'newselect',
                elementConfig: {
                  type: 'text',
                  placeholder: this.props.translate('select') + this.props.translate('maximemAge'),
                  options: [
                    { value: 1209600, label: '2 ' + this.props.translate('weeks') },
                    { value: 1814400, label: '3 ' + this.props.translate('weeks') },
                    { value: 2419200, label: '4 ' + this.props.translate('weeks') },
                    { value: 4838400, label: '8 ' + this.props.translate('weeks') },
                    { value: 7862400, label: '13 ' + this.props.translate('weeks') },
                    { value: 15724800, label: ' 26 ' + this.props.translate('weeks') },
                    { value: 31449600, label: ' 52 ' + this.props.translate('weeks') }
                  ]
                },
                value: {},
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              warning_time: {
                label: this.props.translate('warningTime'),
                elementType: 'newselect',
                elementConfig: {
                  type: 'text',
                  placeholder: this.props.translate('select') + this.props.translate('warningTime'),
                  options: [
                    { value: 43200, label: '12 ' + this.props.translate('hours') },
                    { value: 86400, label: '1 ' + this.props.translate('day') },
                    { value: 172800, label: '2 ' + this.props.translate('days') },
                    { value: 259200, label: '3 ' + this.props.translate('days') },
                    { value: 345600, label: '4 ' + this.props.translate('days') },
                    { value: 432000, label: '5 ' + this.props.translate('days') },
                    { value: 518400, label: '6 ' + this.props.translate('days') },
                    { value: 604800, label: '1 ' + this.props.translate('week') },
                    { value: 0, label: this.props.translate('doNotWarn') }
                  ]
                },
                value: {},
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              grace_limit: {
                label: this.props.translate('graceLimit'),
                elementType: 'input',
                elementConfig: {
                  placeholder: this.props.translate('graceLimit')
                },
                value: '',
                validation: false,
                valid: true,
                touched: false,
                error: null
              }
            }
          }
        }
      },
      is_lockout_col: {
        title: this.props.translate('lockout'),
        open: false,
        form: {
          is_lockout: {
            title: this.props.translate('lockoutEnabled'),
            elementType: 'toggleCheckbox',
            open: false,
            validation: false,
            valid: true,
            form: {
              max_failure: {
                label: this.props.translate('maximumFailure'),
                elementType: 'input',
                elementConfig: {
                  placeholder: this.props.translate('maximumFailure')
                },
                value: '',
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              reset_failure_count: {
                label: this.props.translate('resetFailureCount'),
                elementType: 'newselect',
                elementConfig: {
                  type: 'text',
                  placeholder: this.props.translate('resetFailureCount'),
                  options: [
                    { value: 300, label: '5 ' + this.props.translate('minutes') },
                    { value: 600, label: '10 ' + this.props.translate('minutes') },
                    { value: 1800, label: '30 ' + this.props.translate('minutes') },
                    { value: 3600, label: '1 ' + this.props.translate('hour') },
                    { value: 7200, label: '2 ' + this.props.translate('hours') },
                    { value: 10800, label: '3 ' + this.props.translate('hours') },
                    { value: 21600, label: '6 ' + this.props.translate('hours') },
                    { value: 43200, label: '12 ' + this.props.translate('hours') },
                    { value: 86400, label: '1 ' + this.props.translate('day') },
                    { value: 172800, label: '2 ' + this.props.translate('days') },
                    { value: 259200, label: '3 ' + this.props.translate('days') },
                    { value: 345600, label: '4 ' + this.props.translate('days') },
                    { value: 432000, label: '5 ' + this.props.translate('days') },
                    { value: 518400, label: '6 ' + this.props.translate('days') },
                    { value: 604800, label: '1 ' + this.props.translate('week') }
                  ]
                },
                value: {},
                validation: false,
                valid: true,
                touched: false,
                error: null
              },
              lockout_duration: {
                label: this.props.translate('lockoutDuration'),
                elementType: 'newselect',
                elementConfig: {
                  type: 'text',
                  placeholder:
                    this.props.translate('select') + this.props.translate('lockoutDuration'),
                  options: [
                    { value: 0, label: this.props.translate('unlockedByAdmin') },
                    { value: 300, label: '5 ' + this.props.translate('minutes') },
                    { value: 600, label: '10 ' + this.props.translate('minutes') },
                    { value: 1800, label: '30 ' + this.props.translate('minutes') },
                    { value: 3600, label: '1 ' + this.props.translate('hour') },
                    { value: 7200, label: '2 ' + this.props.translate('hours') },
                    { value: 10800, label: '3 ' + this.props.translate('hours') },
                    { value: 21600, label: '6 ' + this.props.translate('hours') },
                    { value: 43200, label: '12 ' + this.props.translate('hours') },
                    { value: 86400, label: '1 ' + this.props.translate('day') },
                    { value: 172800, label: '2 ' + this.props.translate('days') },
                    { value: 259200, label: '3 ' + this.props.translate('days') },
                    { value: 345600, label: '4 ' + this.props.translate('days') },
                    { value: 432000, label: '5 ' + this.props.translate('days') },
                    { value: 518400, label: '6 ' + this.props.translate('days') },
                    { value: 604800, label: '1 ' + this.props.translate('week') }
                  ]
                },
                value: {},
                validation: false,
                valid: true,
                touched: false,
                error: null
              }
            }
          }
        }
      }
    },
    filterControls: {
      password_policy_id: {
        label: this.props.translate('namePasswordPolicy'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('namePasswordPolicy'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('namePasswordPolicy')
            }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      filterPasswordPolicy: this.props.filterPasswordPolicy
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('passwordPolicy'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('passwordPolicy'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.password_policy_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('passwordPolicy'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.password_policy_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    {
      field: 'password_policy_name',
      title: this.props.translate('namePasswordPolicy'),
      type: 'string'
    }
  ]
  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchPasswordPolicy()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.closeModal()
      this.clearInput()
      this.props.clearSelectedRecord()
      this.setState({
        actionRecordId: null
      })
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    if (props.filterPasswordPolicy !== updateProps.filterPasswordPolicy) {
      updatedState = {
        ...updatedState,
        filterControls: {
          ...state.filterControls,
          password_policy_id: updateFilterOptions(
            props.filterPasswordPolicy,
            state.filterControls.password_policy_id,
            'password_policy_id',
            'password_policy_id',
            'password_policy_name',
            'Select PasswordPolicy'
          )
        },
        updateProps: { ...updateProps, filterPasswordPolicy: props.filterPasswordPolicy }
      }
    }

    if (props.selectedRecord !== updateProps.selectedRecord) {
      let formValid = true
      let newInputGroupState = Object.entries(state.inputGroups).reduce((inputGroups, group) => {
        let [groupKey, groupAttrs] = group

        const newFormData = Object.entries(groupAttrs.form).reduce((formGroups, form) => {
          let [formKey, formAttrs] = form

          let value = ''
          let valid = !formAttrs.validation
          let touched = false
          let errorMessage = null
          if (formAttrs?.elementType === 'checkbox') {
            value = false
          }
          if (props.selectedRecord && props.selectedRecord[formKey]) {
            value = props.selectedRecord[formKey]

            let { isValid, error } = checkValidity(value, formAttrs.validation, formAttrs.label)
            if (formAttrs?.elementType === 'newselect') {
              value = state.inputGroups[groupKey].form[formKey].elementConfig.options.find(
                res => res.value === parseInt(value)
              )
            }
            if (formAttrs?.elementType === 'checkbox') {
              value = true
            }
            valid = isValid
            errorMessage = error
          }

          formValid = formValid && valid
          let newFormAttrs = {
            ...formAttrs,
            value: value,
            valid: valid,
            error: errorMessage,
            touched: touched
          }
          if (formAttrs?.elementType === 'toggleCheckbox') {
            delete newFormAttrs.value
            delete newFormAttrs.error
            newFormAttrs = { ...newFormAttrs, open: value ? true : false }
            const newToggleData = Object.entries(formAttrs.form).reduce((toggleGroups, toggle) => {
              let [toggleKey, toggleAttrs] = toggle

              let value = ''
              let valid = !toggleAttrs.validation
              let touched = false
              let errorMessage = null
              if (formAttrs?.elementType === 'checkbox') {
                value = false
              }
              if (props.selectedRecord && props.selectedRecord[toggleKey]) {
                value = props.selectedRecord[toggleKey]

                let { isValid, error } = checkValidity(
                  value,
                  toggleAttrs.validation,
                  toggleAttrs.label
                )
                if (toggleAttrs?.elementType === 'newselect') {
                  value = state.inputGroups[groupKey].form[formKey].form[
                    toggleKey
                  ].elementConfig.options.find(res => res.value === parseInt(value))
                }
                if (toggleAttrs?.elementType === 'checkbox') {
                  value = true
                }
                valid = isValid
                errorMessage = error
              }

              formValid = formValid && valid
              let newFormAttrs = {
                ...toggleAttrs,
                value: value,
                valid: valid,
                error: errorMessage,
                touched: touched
              }
              return updateObject(toggleGroups, { [toggleKey]: { ...newFormAttrs } })
            }, {})
            newFormAttrs = updateObject(newFormAttrs, { form: newToggleData })
          }

          return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
        }, {})

        const newGroupAttrs = updateObject(groupAttrs, { form: newFormData })
        return updateObject(inputGroups, { [groupKey]: { ...newGroupAttrs } })
      }, {})
      updatedState = {
        ...updatedState,
        inputGroups: newInputGroupState,
        formIsValid: formValid,
        updateProps: { ...updateProps, selectedRecord: props.selectedRecord }
      }
    }
    return updatedState
  }

  onPageChangeHandler = (e, page) => {
    this.props.fetchPasswordPolicy({
      page: page,
      perPage: this.props.pagination.perPage
    })
  }

  onPerPageChangeHandler = perPage => {
    this.props.fetchPasswordPolicy({
      currentPage: this.props.pagination.currentPage,
      perPage
    })
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    const formValid = false
    let newInputGroupState = Object.entries(this.state.inputGroups).reduce((inputGroups, group) => {
      let [groupKey, groupAttrs] = group
      groupAttrs = { ...groupAttrs, open: groupKey === 'general' ? true : false }

      const newFormData = Object.entries(groupAttrs.form).reduce((formGroups, form) => {
        let [formKey, formAttrs] = form

        let value = ''
        let valid = !formAttrs.validation
        let touched = false
        let errorMessage = null

        valid = false
        errorMessage = null

        let newFormAttrs = {
          ...formAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }
        if (formAttrs.elementType === 'checkbox') {
          newFormAttrs = { ...newFormAttrs, value: false, valid: true }
        }
        if (formAttrs.elementType === 'toggleCheckbox') {
          delete newFormAttrs.value
          delete newFormAttrs.error
          newFormAttrs = { ...newFormAttrs, open: false, valid: true }
          const newToggleData = Object.entries(formAttrs.form).reduce((toggleGroups, toggle) => {
            let [toggleKey, toggleAttrs] = toggle

            let value = ''
            let valid = !toggleAttrs.validation
            let touched = false
            let errorMessage = null

            let newFormAttrs = {
              ...toggleAttrs,
              value: value,
              valid: valid,
              error: errorMessage,
              touched: touched
            }
            return updateObject(toggleGroups, { [toggleKey]: { ...newFormAttrs } })
          }, {})
          newFormAttrs = updateObject(newFormAttrs, { form: newToggleData })
        }

        return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
      }, {})

      const newGroupAttrs = updateObject(groupAttrs, { form: newFormData })
      return updateObject(inputGroups, { [groupKey]: { ...newGroupAttrs } })
    }, {})

    this.setState({
      inputGroups: newInputGroupState,
      formIsValid: formValid
    })
  }

  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchPasswordPolicyById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    this.setState({
      modalOpen: false
    })
  }
  clearModal = () => {
    this.closeModal()
    this.clearInput()
    this.props.clearSelectedRecord()
    this.setState({
      actionRecordId: null
    })
  }

  passwordPolicySubmitHandler = e => {
    e.preventDefault()

    function findValue(state, form) {
      Object.entries(state).map(data => {
        let [key, attrs] = data
        if (attrs.value || attrs.value === '' || attrs.value === 0) {
          let value = ''
          if (attrs.elementType === 'newselect') {
            value = attrs.value?.value
          } else {
            value = attrs.value
          }
          form = { ...form, [key]: value }
          return form
        } else if (attrs.elementType === 'toggleCheckbox') {
          form = { ...form, [key]: attrs.open ? 1 : 0 }
          if (attrs.open) {
            form = findValue(attrs.form, form)
          } else {
            Object.entries(attrs.form).map(element => {
              return (form = { ...form, [element[0]]: 0 })
            })
          }
          return form
        } else {
          form = findValue(attrs.form, form)
          return form
        }
      })
      return form
    }
    const passwordPolicyData = findValue(this.state.inputGroups, {})

    if (this.state.action === 'add') {
      this.props.createPasswordPolicy(
        { ...passwordPolicyData },
        getPageStatus(this.props.pagination, false)
      )
    } else if (this.state.action === 'edit') {
      this.props.updatePasswordPolicy(
        this.state.actionRecordId,
        { ...passwordPolicyData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (Key, event) => {
    const inputGroup = this.state.inputGroups
    let passwordPolicyItem = inputGroup

    if (Key.length === 3) {
      passwordPolicyItem = inputGroup[Key[0]].form[Key[1]].form[Key[2]]
    } else {
      passwordPolicyItem = inputGroup[Key[0]].form[Key[1]]
    }
    let inputValue = ''
    switch (passwordPolicyItem.elementType) {
      case 'newselect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !passwordPolicyItem.value
        break
      default:
        inputValue = event.target.value
        break
    }
    const { isValid, error } = checkValidity(
      inputValue,
      passwordPolicyItem.validation,
      passwordPolicyItem.label
    )

    const updatedPasswordPolicyItem = {
      ...passwordPolicyItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGeneralItem = updateObject(inputGroup[Key[0]].form, {
      [Key[1]]: updatedPasswordPolicyItem
    })

    let formIsValid = true
    Object.values(updateGeneralItem).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })

    if (Key.length === 3) {
      passwordPolicyItem = inputGroup[Key[0]].form[Key[1]]

      this.setState({
        inputGroups: updateObject(this.state.inputGroups, {
          [Key[0]]: updateObject(inputGroup[Key[0]], {
            form: updateObject(inputGroup[Key[0]].form, {
              [Key[1]]: updateObject(inputGroup[Key[0]].form[Key[1]], {
                form: updateObject(inputGroup[Key[0]].form[Key[1]].form, {
                  [Key[2]]: updatedPasswordPolicyItem
                })
              })
            })
          })
        }),
        formIsValid: formIsValid
      })
    } else {
      this.setState({
        inputGroups: updateObject(this.state.inputGroups, {
          [Key[0]]: updateObject(inputGroup[Key[0]], {
            form: updateObject(inputGroup[Key[0]].form, { [Key[1]]: updatedPasswordPolicyItem })
          })
        }),
        formIsValid: formIsValid
      })
    }
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true
    })
  }

  toggleCollapse = groupKey => {
    this.setState(prevState => {
      let collapseItem = { ...prevState.inputGroups[groupKey] }
      return {
        inputGroups: {
          ...prevState.inputGroups,
          [groupKey]: { ...collapseItem, open: !collapseItem.open }
        }
      }
    })
  }
  toggleCheckbox = (groupKey, formKey) => {
    this.setState(prevState => {
      let collapseItem = { ...prevState.inputGroups[groupKey] }
      let formItem = { ...collapseItem.form[formKey] }

      return {
        inputGroups: updateObject(prevState.inputGroups, {
          [groupKey]: updateObject(collapseItem, {
            form: updateObject(collapseItem.form, {
              [formKey]: updateObject(formItem, { open: !formItem.open })
            })
          })
        })
      }
    })
  }

  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deletePasswordPolicy(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]

    this.setState(
      {
        filterControls: {
          ...this.state.filterControls,
          [itemKey]: {
            ...filterItem,
            value: filterValue
          }
        },
        filter: { ...this.state.filter, [itemKey]: filterValue?.value }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    this.props.fetchPasswordPolicy(this.state.filter)
    this.closeFilterModal()
  }

  render() {
    let collapseGroup = <Spinner />
    if (!this.props.loading) {
      collapseGroup = Object.entries(this.state.inputGroups).map(item => {
        let [groupKey, groupAttrs] = item

        return (
          <Collapse
            key={groupKey}
            title={groupAttrs.title}
            show={groupAttrs.open}
            toggleBarClicked={() => this.toggleCollapse(groupKey)}>
            <Form
              saved={(formData, event) => this.formSubmitHandler(formData, event)}
              cancelled={this.closeModal}
              form={groupAttrs.form}
              toggleCheckbox={(formKey, e) => this.toggleCheckbox(groupKey, formKey, e)}
              inputChanged={(Key, e) => this.inputChangeHandler([groupKey, ...Key], e)}
              formValid={this.state.formIsValid}
              selectedRecord={this.props.selectedRecord}
            />
          </Collapse>
        )
      })
    }

    const buttonGroups = (
      <div className={classes.ButtonGroup}>
        <span className={classes.Button}>
          <Button
            color={'primary'}
            clicked={this.passwordPolicySubmitHandler}
            disabled={!this.state.formIsValid}>
            {this.props.translate('save')}
          </Button>
        </span>
        <span className={classes.Button}>
          <Button color={'default'} clicked={this.clearModal}>
            {this.props.translate('cancel')}
          </Button>
        </span>
      </div>
    )

    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('passwordPolicy')}
          backdropClicked={this.closeModal}
          footer={buttonGroups}>
          <div className={classes.ModalBody}>{collapseGroup}</div>
        </Modal>
        <div className={classes.Wrapper}>
          <Card>
            <CardHeader>
              <FilterBar buttonClicked={this.openFilterModal} />
            </CardHeader>
            <CardBody>
              <DataTable
                tableTitle={this.props.translate('eMailServer')}
                data={this.props.data}
                structure={this.tableStructure}
                loading={this.props.loading}
                pagination={this.props.pagination}
                pageChange={this.onPageChangeHandler}
                perPageChange={this.onPerPageChangeHandler}
                rowActions={this.rowActions}
              />
            </CardBody>
          </Card>
        </div>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.passwordPolicy.pagination,
    data: state.passwordPolicy.records,
    loading: state.passwordPolicy.loading,
    filterLoading: state.passwordPolicy.filterLoading,
    success: state.passwordPolicy.success,
    selectedRecord: state.passwordPolicy.selectedRecord,
    filterPasswordPolicy: state.passwordPolicy.filterPasswordPolicy
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchPasswordPolicy: filterOptions => dispatch(actions.fetchPasswordPolicy(filterOptions)),
    fetchPasswordPolicyById: recordId => dispatch(actions.fetchPasswordPolicyById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedPasswordPolicyRecord()),
    createPasswordPolicy: (recordData, page) =>
      dispatch(actions.createPasswordPolicy(recordData, page)),
    updatePasswordPolicy: (recordId, recordData, page) =>
      dispatch(actions.updatePasswordPolicy(recordId, recordData, page)),
    deletePasswordPolicy: (recordId, page) =>
      dispatch(actions.deletePasswordPolicy(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchPasswordPolicyMinimumAgeOptions())
      dispatch(actions.fetchPasswordPolicyResetTicketMaxAgeOptions())
      dispatch(actions.fetchPasswordPolicyHistoryCountOptions())
      dispatch(actions.fetchPasswordPolicyMaximumAgeOptions())
      dispatch(actions.fetchPasswordPolicyWarningTimeOptions())
      dispatch(actions.fetchPasswordPolicyResetFailureCountOptions())
      dispatch(actions.fetchPasswordPolicyLockoutDurationOptions())
    },
    fetchFilter: filter => {
      dispatch(actions.fetchPasswordPolicyFilterPasswordPolicy(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(PasswordPolicy))
